// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"a3c1d916","27":"a32213e7","142":"699b1cea","301":"d7104659","406":"e1e71017","802":"0d78c379"}[chunkId] + ".chunk.js";
};